import Controller from "./Controller.js";
import { trace } from 'rytm-helpers'
import { buildOwl, destroyOwl } from './../shared/owlcarousel'

/**
 * Odpowiada za nawigację poprzedni / następny obiekt
 */
class RowlCarouselController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    buildOwl(0)
  }
  /**
  * Add event listeners called on <code>onViewShow()</code>
  **/
  addEventListeners() {
    super.addEventListeners();
  }
  /**
  * Remove event listeners called on <code>onViewHide()</code>
  **/
  removeEventListeners() {
    super.removeEventListeners();
  }
  /**
  * on view shown - animation in / show complete
  * @param {Event} e
  **/
  onViewShown(e) {
    
  }
  onViewHidden(e) {
    super.onViewHidden(e)
    destroyOwl();
  }
  
}
export default RowlCarouselController